import React, { useState } from 'react';

export default function ThinkyIOTServerScalability({ onBack }) {
  const [servers] = useState([
    { id: 1, name: 'Server A', role: 'Master', status: 'Online', uptime: '72h' },
    { id: 2, name: 'Server B', role: 'Slave', status: 'Online', uptime: '68h' },
    { id: 3, name: 'Server C', role: 'Slave', status: 'Offline', uptime: 'N/A' },
    { id: 4, name: 'Server D', role: 'Load Balancer', status: 'Online', uptime: '75h' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">High Availability & Scalability</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {servers.map(server => (
          <div key={server.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{server.name}</h3>
            <p>Role: <span className="text-blue-400 font-medium">{server.role}</span></p>
            <p>Status: <span className={`${server.status==='Online' ? 'text-green-400' : 'text-red-500'} font-semibold`}>{server.status}</span></p>
            <p>Uptime: <span className="font-medium">{server.uptime}</span></p>
          </div>
        ))}
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-semibold mb-3">Cluster Summary</h2>
        <ul className="list-disc list-inside text-sm">
          <li>Total Servers: {servers.length}</li>
          <li>Online: {servers.filter(s => s.status==='Online').length}</li>
          <li>Offline: {servers.filter(s => s.status==='Offline').length}</li>
        </ul>
      </section>
    </div>
  );
}
